import { ADD_CALL, ADD_INCOMMING_CALL, ADD_USER, OnlineActionTypes,
    REMOVE_CALL, REMOVE_INCOMMING_CALL, REMOVE_USER, SET_USERS } from "../actionTypes"
import { OnlineState } from "../types"

export const onlineInitState: OnlineState = {
    onlineUsers: [],
    incommingCall: null,
    call: null
}

export const OnlineReducer = (state = onlineInitState, action: OnlineActionTypes): OnlineState => {
    switch (action.type) {
        case SET_USERS:
            return {
                ...state,
                onlineUsers: action.users
            }
        case ADD_USER:
            return {
                ...state,
                onlineUsers: [...state.onlineUsers, action.user]
            }
        case REMOVE_USER:
            return {
                ...state,
                onlineUsers: [...state.onlineUsers.filter(x => x !== action.user)]
            }
        case ADD_INCOMMING_CALL:
            return {
                ...state,
                incommingCall: action.incommingCall
            }
        case REMOVE_INCOMMING_CALL:
            return {
                ...state,
                incommingCall: null
            }
        case ADD_CALL:
            return {
                ...state,
                call: action.call
            }
        case REMOVE_CALL:
            return {
                ...state,
                call: null
            }    
        default:
            return state;
    }
}